import { apiCand, CAND_TOKEN_KEY, CAND_USER_KEY } from "./apiCandidato";

// ---- público ----
export const infoInscricao = (token) => apiCand.get(`/candidato/inscricao/${token}`);
export const buscarCpf = (cpf) => apiCand.get(`/candidato/buscar-cpf/${cpf}`);
export const getEstados = () => apiCand.get("/lookup/estados");
export const getCidades = (codUf) => apiCand.get(`/lookup/cidades/${codUf}`);
export const getTiposDocumentoCand = () => apiCand.get("/lookup/tipos-documento");

export const registrar = async (dto) => {
  const { data } = await apiCand.post("/candidato/registrar", dto);
  sessao(data);
  return data;
};

export const loginCandidato = async (login, senha) => {
  const { data } = await apiCand.post("/candidato/login", { Login: login, Senha: senha });
  sessao(data);
  return data;
};

// ---- redefinição de senha ----
export const esqueciSenha = (login) => apiCand.post("/candidato/esqueci-senha", { Login: login });
export const validarReset = (token) => apiCand.get(`/candidato/validar-reset/${token}`);
export const redefinirSenha = (token, novaSenha) =>
  apiCand.post("/candidato/redefinir-senha", { Token: token, NovaSenha: novaSenha });

const sessao = (data) => {
  localStorage.setItem(CAND_TOKEN_KEY, data.token);
  localStorage.setItem(CAND_USER_KEY, JSON.stringify(data.candidato));
};

export const logoutCandidato = () => {
  localStorage.removeItem(CAND_TOKEN_KEY);
  localStorage.removeItem(CAND_USER_KEY);
};
export const candidatoLogado = () => !!localStorage.getItem(CAND_TOKEN_KEY);
export const getCandidato = () => {
  try { return JSON.parse(localStorage.getItem(CAND_USER_KEY) || "null"); } catch { return null; }
};

// ---- ficha (autenticado como candidato) ----
export const getPerfil = () => apiCand.get("/candidato/perfil");
export const salvarPerfil = (dto) => apiCand.post("/candidato/perfil", dto);

export const minhasFichas = () => apiCand.get("/candidato/minhas-fichas");
export const minhaFicha = (token) => apiCand.get(`/candidato/minha-ficha/${token}`);
export const salvarMinhaFicha = (dto) => apiCand.post("/candidato/ficha/salvar", dto);
export const enviarMinhaFicha = (idFicha) => apiCand.post(`/candidato/ficha/enviar/${idFicha}`);

// ---- eventos ----
export const getEventosPublicos = () => apiCand.get("/evento/publicos");
export const getEventoPublico = (id) => apiCand.get(`/evento/publico/${id}`);
export const eventoBannerUrl = (id) => `/api/evento/banner-img/${id}`;
export const getMatriculasEvento = () => apiCand.get("/candidato/evento/matriculas");
export const inscreverEvento = (idEvento, idEventoValor, matriculas, opcoes) =>
  apiCand.post("/candidato/evento/inscrever", {
    IdEvento: idEvento, IdEventoValor: idEventoValor || null,
    Matriculas: matriculas || [], Opcoes: opcoes || [],
  });
export const minhasInscricoesEvento = () => apiCand.get("/candidato/eventos/minhas");
export const getCobranca = (id) => apiCand.get(`/candidato/evento/cobranca/${id}`);
export const cancelarCobranca = (id) => apiCand.post(`/candidato/evento/cobranca/cancelar/${id}`);
export const regerarPix = (id) => apiCand.post(`/candidato/evento/cobranca/${id}/gerar-pix`);

// ---- recurso ----
export const getRecurso = (idFicha) => apiCand.get(`/candidato/recurso/${idFicha}`);
export const salvarRecurso = (idFicha, descricao) =>
  apiCand.post("/candidato/recurso", { IdFicha: idFicha, Descricao: descricao });
export const listarAnexosRecursoCand = (idRecurso) => apiCand.get(`/anexo/recurso/${idRecurso}`);

// categorias de receita/despesa (endpoint aberto)
export const getTiposLancamento = (natureza) =>
  apiCand.get(`/lookup/tipos-lancamento${natureza ? `?natureza=${natureza}` : ""}`);

// ---- anexos do candidato (mesmo endpoint, com checagem de propriedade no backend) ----
export const listarAnexosCand = (idFicha) => apiCand.get(`/anexo/ficha/${idFicha}`);
export const uploadAnexoCand = (idFicha, arquivo, categoria, idTipoDocumento, idRecurso) => {
  const fd = new FormData();
  fd.append("arquivo", arquivo);
  if (categoria) fd.append("categoria", categoria);
  if (idTipoDocumento) fd.append("idTipoDocumento", idTipoDocumento);
  if (idRecurso) fd.append("idRecurso", idRecurso);
  return apiCand.post(`/anexo/upload/${idFicha}`, fd, { headers: { "Content-Type": undefined } });
};
export const excluirAnexoCand = (id) => apiCand.post(`/anexo/excluir/${id}`);
export const getAnexoBlobCand = (id) =>
  apiCand.get(`/anexo/download/${id}`, { responseType: "blob" }).then((r) => r.data);
export const baixarAnexoCand = async (id, nomeOriginal) => {
  const { data } = await apiCand.get(`/anexo/download/${id}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url; a.download = nomeOriginal || `anexo_${id}`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
